import { useEffect } from 'react';

/**
 * SEO Head component for dynamic meta tags in React SPA
 * Updates document title and meta tags based on current page/asset type
 */
export const SEOHead = ({ assetType = 'Stock' }) => {
  useEffect(() => {
    // Update document title based on asset type
    const titles = {
      'Stock': 'Stocks - catchfire.finance | Stock Market Data Visualization',
      'Crypto': 'Cryptocurrency - catchfire.finance | Crypto Market Data Visualization',
      'Forex': 'Forex - catchfire.finance | Foreign Exchange Market Data Visualization'
    };
    
    document.title = titles[assetType] || 'catchfire.finance - Interactive Financial Data Visualization';
    
    // Update meta description
    const descriptions = {
      'Stock': 'Explore interactive stock market data visualizations. Real-time network graphs showing stock correlations and relationships.',
      'Crypto': 'Explore interactive cryptocurrency market data visualizations. Real-time network graphs showing crypto correlations and relationships.',
      'Forex': 'Explore interactive forex market data visualizations. Real-time network graphs showing currency pair correlations and relationships.'
    };
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', descriptions[assetType] || descriptions['Stock']);
    
    // Update canonical URL (if needed for future routing)
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://catchfire.finance/${assetType.toLowerCase()}`);
    
  }, [assetType]);
  
  return null; // This component doesn't render anything
};

